module.exports = __webpack_public_path__ + "static/media/federico-fernandez.c314698d.jpg";